import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import styles from './SettingsMismatchModal.module.css';


function SettingsMismatchModal(props) {

  const {
    mode,
    show,
    onHide,
    values,
    handleDelete,
  } = props;

  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const bookingData = (values?.bookingData && values.bookingData[0]);
  
  const getRentalNameById = (rentalId) => {
    return rentals.find(rental => rental.id === rentalId)?.name || 'N/A';
  };

  const handleAction = () => {
    if (values) {
      const { id } = values;
      handleDelete(id);
    };
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>
          A new reservation was successfully received from an OTA and saved in Beehaz.
        </p>
        <p>
          However, we detected that this reservation falls outside one or more of the parameters you’ve set in your Beehaz settings. This may indicate that your OTA settings differ from those configured in Beehaz.
        </p>
        <p>
          The reservation appears to fall outside one of the following limits:
        </p>
        <p>
          <div style={{display: 'flex'}}>
            <div style={{paddingInline: '20px'}}>-</div><div>Minimum or maximum stay requirement.</div>
          </div>
          <div style={{display: 'flex'}}>
            <div style={{paddingInline: '20px'}}>-</div><div>Maximum number of guests.</div>
          </div>
          <div style={{display: 'flex'}}>
            <div style={{paddingInline: '20px'}}>-</div><div>Booking window (calendar availability).</div>
          </div>
        </p>
        <p>
          There was no issue with the reservation itself — this notification is for your information only.
        </p>
        <p>Reservation details:</p>
        <p style={{display: 'flex'}}>
          <div style={{paddingLeft: '20px'}}>
            <div>OTA:</div>
            <div>Reservation:</div>
            <div>Rental:</div>
            <div>Arrival date:</div>
          </div>
          <div style={{paddingLeft: '70px'}}>
            <div>{bookingData?.ota}</div>
            <div>{bookingData?.suBookingId}</div>
            <div>{getRentalNameById(bookingData?.rentalId)}</div>
            <div>{moment(bookingData?.arrive).format('DD MMMM YYYY') || 'N/A'}</div>
          </div>
        </p>
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleClose}
            className={styles.grayButton}
          >
            Close
          </button>
          { mode === 'notification' &&
            <button
              onClick={handleAction}
              className={styles.redButton}
            >
              Delete Notification
            </button>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SettingsMismatchModal;